'use es6';

import createBatchedReferenceResolver from 'reference-resolvers/lib/createBatchedReferenceResolver';
import * as CacheKeys from 'reference-resolvers/constants/CacheKeys';
import { QUOTE } from 'reference-resolvers/constants/ReferenceObjectTypes';
import { getObjectsByIds, searchObjects, createGetObjectsByIds, createSearchObjects } from 'reference-resolvers/api/ContactSearchAPI';
export const createQuoteReferenceResolver = options => createBatchedReferenceResolver(Object.assign({
  cacheKey: CacheKeys.QUOTES,
  createFetchByIds: opts => createGetObjectsByIds(opts)(QUOTE),
  createFetchSearchPage: opts => createSearchObjects(opts)(QUOTE),
  fetchByIds: getObjectsByIds(QUOTE),
  fetchSearchPage: searchObjects(QUOTE)
}, options));
export default createQuoteReferenceResolver();